export const API_ROOT = 'https://dealercmsapi.fastcrm.biz/'
export const API_ROOT_DRONE = 'https://drone.perimetertechnologies.com/'
// export const API_ROOT = 'http://10.0.0.36:6768/'
export const IS_DESKTOP_APP = false
